// en, de, fr, pt
export default {
    en: {
        Dashboard: 'Dashboard',
        Settings: 'Settings',
        Sites: 'Sites',
        Users: 'Users',
        Languages: 'Languages',
        Classifications: 'Course Classifications',
        ModuleGroups: 'Module Groups',
        SelectCourse: 'Select Course',
        ModuleDocuments: 'Module Documents',
        BulkUploadCourses: 'Bulk Upload Courses',
        BulkUploadSchedules: 'Bulk Upload Schedules',
        CourseBuilder: 'Course Builder',
        PremiumContent: 'Premium Content',
        Navigation: 'Navigation Maps',
        Scene: 'Scenes',
        Background: 'Backgrounds',
        Music: 'Audio / Podcasts',
        Scenes: 'Scenes',
        Characters: 'Characters',
        Video: 'Videos',
        iSpringQuiz: 'iSpring Quizzes',
        iSpringPresentation: 'iSpring Presentations',
        Document: 'Documents',
        Quiz: 'Quizzes',
        Manage: 'Manage',
        Courses: 'Courses & Modules',
        Students: 'Students',
        studentDocs: 'Student Documents',
        Snapshot: 'Snapshot',
        DeviceType: 'Device Type',
        Assessment: 'Assessment',
        PredefinedComment: 'Predefined Comments',
        AssessTask: 'Assess Tasks',
        ModerateTask: 'Moderate Tasks',
        Assign: 'Assign',
        Companies: 'Companies',
        Marketing: 'Marketing',
        ManageVideos: 'Manage Videos',
        Evaluate: 'Evaluate',
        EvaluateTask: 'Evaluate Tasks',
        Reports: 'Reports',
        ViewReports: 'View Reports',
        DocumentTypes: 'Document Types',
        LearnerReviewQuestions: 'Learner Review Questions',
        WitnessTestimonyQuestion: 'Witness Testimony Question',
        ResourceCategory: 'Resource Category',
        AdditionalResources: 'Additional Resources',
        PracticalQuestions: 'Practical Questions',
        Guardians: 'Guardians',
        AddShortCourse: 'Add Short Course',
        ShortCourseList: 'Short Courses',
        SARSQuestions: 'SARS Questions',
        AddBundle:'Add Bundle',
        BundleList:'Bundle List',
        Vendors: "Vendors & Vouchers",
        Monitor:"Monitor",
        Assessments:"Assessments",
        Principal:"Principal",
        DataPlans:"Data Plans",
        MobilePlans:"Mobile Plans",
        Banners:"Banners",
        BulkUploadFeedback:"Bulk Upload Feedback",
        SubscriptionReport:"Subscription Report"
    },
    // de: {

    // },
    // fr: {

    // },
    // pt: {

    // }
}
